import { ReactNode } from "react";
import clsx from "clsx";

export type TabsPanelsProps = {
  className?: string;
  children: ReactNode;
};

export const TabsPanels = ({ className, children }: TabsPanelsProps) => {
  return <div className={clsx(className)}>{children}</div>;
};
